//import bootstrap
import 'bootstrap'
import '../scss/bootstrap.scss'

import Vue from 'vue'
import VueCookie from "vue-cookie";

import Axios from './plugins/axios'
import arrive from 'arrive'
import App from './App.vue'
import VueGtm from 'vue-gtm';

// import './plugins/hyphenator.js';

//import main scss
import '../scss/style.scss'
import '../scss/accessibility.scss'

import './plugins/font_awesome.js'

Vue.config.productionTip = false;

if (typeof fcwp_vue_data.sitemeta !== 'undefined' && typeof fcwp_vue_data.sitemeta.gtag_manager === 'string' && fcwp_vue_data.sitemeta.gtag_manager != '') {
  Vue.use(VueGtm, {
    id: fcwp_vue_data.sitemeta.gtag_manager,
  });
}

Vue.use(VueCookie);

new Vue({
  el: '#app',
  render(h) {
    return h(App)
  },
});

